module.exports = __webpack_public_path__ + "static/media/donation.90aa20a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/donation.svg
// module id = 791
// module chunks = 0